// src/components/shared/Card.jsx
import React from 'react';
import { styles } from '../../styles/theme';

/**
 * Reusable Card Component
 */
export const Card = ({ 
  children, 
  title, 
  subtitle,
  headerAction,
  padding = 'normal',
  borderColor,
  ...props 
}) => {
  const getPaddingStyle = () => {
    switch(padding) {
      case 'none':
        return { padding: 0 };
      case 'small':
        return { padding: '0.75rem' };
      case 'normal':
        return { padding: '1.5rem' };
      case 'large':
        return { padding: '2rem' };
      default:
        return { padding: '1.5rem' };
    }
  };

  const cardStyle = {
    ...styles.card,
    ...getPaddingStyle(),
    ...(borderColor && { borderLeft: `4px solid ${borderColor}` })
  };

  return (
    <div style={cardStyle} {...props}>
      {(title || subtitle || headerAction) && (
        <div style={styles.flexBetween}>
          <div>
            {title && (
              <h2 style={{ 
                margin: '0 0 0.5rem 0', 
                fontSize: '1.25rem', 
                fontWeight: 'bold',
                color: '#1f2937'
              }}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p style={{ 
                margin: 0, 
                fontSize: '0.875rem', 
                color: '#6b7280' 
              }}>
                {subtitle}
              </p>
            )}
          </div>
          {headerAction && <div>{headerAction}</div>}
        </div>
      )}
      {children}
    </div>
  );
};

/**
 * Stats Card Component
 */
export const StatsCard = ({ 
  value, 
  label, 
  icon: Icon, 
  color = '#3b82f6',
  trend,
  ...props 
}) => {
  return (
    <div style={{ ...styles.statsCard, borderLeft: `4px solid ${color}` }} {...props}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between' 
      }}>
        <div>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#6b7280', 
            margin: '0' 
          }}>
            {label}
          </p>
          <p style={{ 
            fontSize: '2rem', 
            fontWeight: 'bold', 
            color: color, 
            margin: '0.25rem 0' 
          }}>
            {value}
          </p>
          {trend && (
            <p style={{ 
              fontSize: '0.75rem', 
              color: '#9ca3af', 
              margin: '0' 
            }}>
              {trend}
            </p>
          )}
        </div>
        {Icon && (
          <div style={{ 
            padding: '0.75rem', 
            backgroundColor: `${color}20`, 
            borderRadius: '8px' 
          }}>
            <Icon style={{ width: '24px', height: '24px', color: color }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;